document.addEventListener("DOMContentLoaded", function(){

/* ===== DRAPRON_SIZE_MODAL_v1 ===== */

const modal = document.getElementById("sizeModal");
const box = document.getElementById("sizeBox");
const openBtn = document.getElementById("openSizeBtn");
const closeBtn = document.getElementById("closeSize");
const maleBtn = document.getElementById("maleBtn");
const femaleBtn = document.getElementById("femaleBtn");
const tableBox = document.getElementById("tableBox");

if(!modal || !openBtn) return;

let scrollY = 0;

// MOVE MODAL
document.body.appendChild(modal);

// LOCK SCROLL
function lockScroll(){
  scrollY = window.scrollY;
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.width = "100%";
}

// UNLOCK
function unlockScroll(){
  document.body.style.position = "";
  document.body.style.top = "";
  window.scrollTo(0, scrollY);
}

// OPEN
openBtn.onclick = function(){
  modal.style.display = "flex";
  lockScroll();
  showMale();
};

// CLOSE
closeBtn.onclick = closeModal;

modal.addEventListener("click", function(e){
  if(!box.contains(e.target)){
    closeModal();
  }
});

function closeModal(){
  modal.style.display = "none";
  unlockScroll();
}

// ALLOW SCROLL ONLY INSIDE BOX
box.addEventListener("touchmove", function(e){
  e.stopPropagation();
}, {passive:true});

// RENDER
function render(data){
  let html = `<table>
  <tr><th>Size</th><th>Chest</th><th>Shoulder</th><th>Length</th></tr>`;
  data.forEach(r=>{
    html += `<tr><td>${r[0]}</td><td>${r[1]}</td><td>${r[2]}</td><td>${r[3]}</td></tr>`;
  });
  html += "</table>";
  tableBox.innerHTML = html;
}

// DATA
function showMale(){
  render([
    ["XS","33–35","17","29"],
    ["S","35–37","17.5","29.5"],
    ["M","37–39","18","30"],
    ["L","39–41","18.5","30.5"],
    ["XL","41–43","19","31"],
    ["2XL","43–45","19.5","31.5"],
    ["3XL","45–47","20","32"],
    ["4XL","47–49","20.5","32.5"]
  ]);
  maleBtn.classList.add("active");
  femaleBtn.classList.remove("active");
}

function showFemale(){
  render([
    ["XS","31–33","15.5","26"],
    ["S","33–35","16","27"],
    ["M","35–37","16.5","28"],
    ["L","37–39","17","29"],
    ["XL","39–41","17.5","30"],
    ["2XL","41–43","18","31"],
    ["3XL","43–45","18.5","32"],
    ["4XL","45–47","19","33"]
  ]);
  femaleBtn.classList.add("active");
  maleBtn.classList.remove("active");
}

maleBtn.onclick = showMale;
femaleBtn.onclick = showFemale;

});